import {
  SET_IS_START_MASS_UPLOAD,
  SET_IS_FAILED_MASS_UPLOAD,
} from 'storeContext/actionsType/massUpload'
import type { MassUploadActionType } from 'storeContext/actions/massUpload/types'

export interface MassUploadStateType {
  isLoading: boolean
  needToReload: number
}

export const initialStateMassUpload = {
  isLoading: false,
  needToReload: 1,
}

export default function massUpload(
  state: MassUploadStateType = initialStateMassUpload,
  { type, payload: _payload }: MassUploadActionType,
) {
  switch (type) {
    case SET_IS_START_MASS_UPLOAD:
      return {
        ...state,
        isLoading: true,
      }
    case SET_IS_FAILED_MASS_UPLOAD:
      return {
        ...state,
        isLoading: false,
      }
    default:
      return {
        ...state,
      }
  }
}
